import { useMsal } from "@azure/msal-react";
import { Autocomplete, TextField } from '@mui/material';
import axios from "axios";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAllGMPPlannerEmailData, getAllUsersPlannerMaterial, getLTPlannerDropdownData, saveLtPlannerMaterialEndpoint, searchLtPlannerMaterialEndpoint, updateLtPlannerMaterialEndpoint } from '../../../common/endpoints';
import Dropdown from '../../../components/common/Dropdown';
import { Loader } from '../../../components/common/Loader';
import { MultiDropdown } from '../../../components/common/MultiDropdown';
import TabSection from "../../../components/common/TabSection";
import ActionInput from '../../../components/common/actioninput/ActionInputField';
import ButtonComponent from '../../../components/common/button/Button';
import DataTable from '../../../components/common/datatable/DataTable';
import Modal from '../../../components/common/modal/Modal';
import { getAllUsersData } from '../../../redux/actions/Admin/GetAllUsers';
import { getPlannerMaterialDropdownData } from '../../../redux/actions/Admin/LTPlannerMaterialDropdownDataSlice';
import { postSaveLTPlannerMaterial } from '../../../redux/actions/Admin/SaveLTPlannerMaterialSlice';
import { postSearchLTPlannerMaterial } from '../../../redux/actions/Admin/SearchLTPlannerMaterialSlice';
import { postEditLTPlannerMaterial } from '../../../redux/actions/Admin/UpdateLTPlannerEditSlice';
import ExcelUpdate from '../ParameterConfiguration/ExcelUpdate';
import { FileOverivew, FileOverivewFooter } from '../ParameterConfiguration/FileOverview';
import TopSection from '../TopSection';
import { EditPlannerMaterialHeaders } from './EditPlannerMaterialHeaders';
import './index.css';
import { getAllGMPUsersData } from "../../../redux/actions/Admin/GetAllGMPUsers";

const PlannerMaterialMapping = () => {
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const [tabValue, setTabValue] = useState(0);
  const [selectedPlanner, setSelectedPlanner] = useState([]);
  const [overview, setOverview] = useState(false);
  const [fileName, setFileName] = useState('');
  const [xlDetails, setXLDetails] = useState({});
  const [mrpControllerEmailData, setMRPControllerEmailData] = useState([]);
  const [GMPEmailData, setGMPEmailData] = useState([]);
  const [isWindowFileSelected, setIsWindowFileSelected] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedEditItem, setSeletedEditItem] = useState({});
  const [excelLoader, setExcelLoader] = useState(false);

  const [formData, setFormData] = useState({
    plant: [],
    scode: [],
    purchasingGroup: [],
    materialType: [],
    materialId: [],
    materialGroup: [],
  });
  const [show, setShow] = useState(false);
  const [dropdownData, setDropdownData] = useState();
  const [plantData, setPlantData] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [purchasingGroupData, setPurchasingGroupData] = useState([]);
  const [scodeData, setScodeData] = useState([]);
  const [materialGroupData, setMaterialGroupData] = useState([]);
  const [materialTypeData, setMaterialTypeData] = useState([]);
  const [materialIdData, setMaterialIdData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [fileOverviewDetails, setFileOverviewDetails] = useState({});
  const [selectedEditPlanner, setSelectedEditPlanner] = useState({});
  const userRole = localStorage.getItem("LTRole");

  const pagination = true;
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 30, 50, 100];

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      const uniqueValues = [...new Set(data?.map(item => item[key]))];
      return uniqueValues?.map(value => ({ label: value, value: value, title: value }));
    }
    else {
      return []
    }
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handlePlannerChange = (event, newValue) => {
    setSelectedPlanner(newValue)
  }
  const handlEditMRP = (event, newValue) => {
    setSelectedEditPlanner(newValue)
  }

  const isUploadFileSelected = () => {
    setIsWindowFileSelected(true)
  }

  const handleSelectedRole = (e) => {
    setSelectedRole(e.target.value);
    setSelectedPlanner([])
  }

  // Callback function to handle selected items
  const handleSelectedItemsChange = (name, newSelectedItems) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newSelectedItems,
    }));
    if (name === "plant") {
      setPlantData([])
      setScodeData([]);
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setPurchasingGroupData([]);
      setSelectedPlanner([]);
      setFormData((prevData) => ({
        ...prevData,
        materialType: [],
        materialId: [],
        materialGroup: [],
        purchasingGroup: [],
        scode: []
      }));
      // setPlantData(newSelectedItems.target.value);
      // setPurchasingGroupData(dropdownData?.filter(item => item.plant === newSelectedItems.target.value))

      const filterValues = newSelectedItems?.map((group) => group.value);
      setPlantData(filterValues)
      const filteredPurchasingGroup = dropdownData?.filter((item) =>
        filterValues?.includes(item.plant)
      );
      const uniquePurchasingData = filteredPurchasingGroup?.filter((item) => item.purchasingGroup);
      setPurchasingGroupData(uniquePurchasingData)
    }
    if (name === "purchasingGroup") {
      setScodeData([])
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: [],
        materialGroup: [],
        materialType: [],
        scode: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = purchasingGroupData?.filter((item) =>
        filterValues?.includes(item.purchasingGroup)
      );
      const uniqueSCode =
        filteredPurchasingGroup?.filter((item) => item.scode);
      setScodeData(uniqueSCode)
    }
    if (name === "scode") {
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: [],
        materialGroup: [],
        materialType: [],
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredSCode = scodeData?.filter((item) =>
        filterValues?.includes(item.scode)
      );
      const uniqueMaterialTypes =
        filteredSCode?.filter((item) => item?.materialType);
      setMaterialTypeData(uniqueMaterialTypes)
    }
    if (name === "materialType") {
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: [],
        materialGroup: [],
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredMaterialTypes = materialTypeData?.filter((item) =>
        filterValues?.includes(item.materialType)
      );
      const uniqueMaterialGroup =
        filteredMaterialTypes?.filter((item) => item?.materialGroup);
      setMaterialGroupData(uniqueMaterialGroup)
    }

    if (name === "materialGroup") {
      setMaterialIdData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredMaterialGroup = materialGroupData?.filter((item) =>
        filterValues?.includes(item.materialGroup)
      );
      const uniqueMaterialID =
        filteredMaterialGroup?.filter((item) => item.materialId);
      setMaterialIdData(uniqueMaterialID)
    }
  }

  const onClickSearchButton = async () => {
    const materialIds = formData?.materialId?.map(item => item?.value?.split("|")[0]);

    const searchRequestBody = {
      "plants": plantData,
      "materialIds": materialIds
    }

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSearch = await dispatch(postSearchLTPlannerMaterial({
        dynamicEndpoint: `${searchLtPlannerMaterialEndpoint}`,
        data: searchRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSearch.meta.requestStatus === 'fulfilled') {
        setSearchResults(responseSearch?.payload);
        setShow(true)
      } else {
        setSearchResults([])
        toast.error(responseSearch?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const { instance, accounts } = useMsal();
  const fetchData = async () => {
    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseLTPlannerDropdown = await dispatch(getPlannerMaterialDropdownData({
        dynamicEndpoint: `${getLTPlannerDropdownData}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseLTPlannerDropdown.meta.requestStatus === 'fulfilled') {
        setDropdownData(responseLTPlannerDropdown?.payload);
      } else {
        toast.error(responseLTPlannerDropdown?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }

    try {
      const responseGetAllUsers = await dispatch(getAllUsersData({
        dynamicEndpoint: `${getAllUsersPlannerMaterial}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseGetAllUsers.meta.requestStatus === 'fulfilled') {
        const loggedInUserEmail = localStorage.getItem("data");
        // const filteredUsers = responseGetAllUsers?.payload?.filter(user => user.email !== loggedInUserEmail);

        setMRPControllerEmailData(responseGetAllUsers?.payload);
      } else {
        toast.error(responseGetAllUsers?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }

    try {
      const responseGetAllGMPUsers = await dispatch(getAllGMPUsersData({
        dynamicEndpoint: `${getAllGMPPlannerEmailData}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseGetAllGMPUsers.meta.requestStatus === 'fulfilled') {
        const loggedInUserEmail = localStorage.getItem("data");
        // const filteredUsers = responseGetAllUsers?.payload?.filter(user => user.email !== loggedInUserEmail);

        setGMPEmailData(responseGetAllGMPUsers?.payload);
      } else {
        toast.error(responseGetAllGMPUsers?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  useEffect(() => {
    if (accounts?.length) {
      fetchData();
    } else {
      console.log("No accounts exist to get access token");
    }
  }, []);

  const handleManualDataSubmit = async () => {
    const userEmail = localStorage.getItem("data");
    const materialIds = formData?.materialId?.map(item => item?.value?.split("|")[0]);

    const manualUpdateRequestBody = {
      "userEmail": userEmail,
      "plants": plantData,
      "materialIds": materialIds,
      "plannerName": selectedPlanner?.name,
      "plannerEmail": selectedPlanner?.email,
      "role": selectedRole
    }

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseSaveLTPlannerMaterial = await dispatch(postSaveLTPlannerMaterial({
        dynamicEndpoint: `${saveLtPlannerMaterialEndpoint}`,
        data: manualUpdateRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSaveLTPlannerMaterial.meta.requestStatus === 'fulfilled') {
        toast.success(responseSaveLTPlannerMaterial?.payload, {
          autoClose: 2000,
        });
        clearAllData();
      } else {
        toast.error(responseSaveLTPlannerMaterial?.payload, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const clearAllData = () => {
    setFormData({
      plant: [],
      scode: [],
      purchasingGroup: [],
      materialType: [],
      materialId: [],
      materialGroup: [],
    })
    setPlantData([]);
    setScodeData([]);
    setMaterialGroupData([]);
    setMaterialIdData([]);
    setMaterialTypeData([]);
    setPurchasingGroupData([]);
    setSelectedPlanner([]);
    setSearchResults([]);
    setFileOverviewDetails([])
    setShow(false);
    setSelectedRole("");
    fetchData();
  }

  const getFileName = (fileName, obj = {}) => {
    setFileName(fileName);
    setXLDetails(obj);
  }

  const handleFileSaveAPI = async () => {

    const userEmail = localStorage.getItem("data");

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    const uploadPlannerUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/admin/uploadLtCsvPlannerMaterial/${userEmail}`;
    setExcelLoader(true);
    axios.post(uploadPlannerUrl, xlDetails,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          withCredentials: true,
          "Content-Type": "multipart/form-data",
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode"),
          userEmail: localStorage.getItem("data"),
          ltRole: localStorage.getItem("LTRole"),
          cdRole: localStorage.getItem("CDRole"),
          ltRegion: localStorage.getItem("LTRegion")
        }
      }
    )
      .then(function (response) {
        if (response) {
          if (response.status === 200) {
            setExcelLoader(false);
            toast.success("File Uploaded Successfully", {
              autoClose: 2000,
            });
            setFileOverviewDetails({ headers: response?.headers, data: response?.data });
            setIsWindowFileSelected(false)
          }
        }
      })
      .catch(function (error) {
        setExcelLoader(false);
        if (error?.response?.data?.errorMessage?.includes("Columns are not as expected")) {
          toast.error("Columns are not as expected", {
            autoClose: 2000,
          });
        } else {
          toast.error(error?.response?.data?.errorMessage, {
            autoClose: 2000,
          });
        }
      });
  }

  const onClickEditExistingRecords = (item) => {
    setSeletedEditItem(item.data);
    setEditModalOpen(true);
  }
  const onClickDeleteLineItem = async (item) => {
    const userEmail = localStorage.getItem("data");

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    const deletePlannerUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/admin/deleteLtPlannerMaterial/${item?.data?.uniqueId}/${userEmail}`;
    axios.delete(deletePlannerUrl,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          withCredentials: true
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode"),
          userEmail: localStorage.getItem("data"),
          ltRole: localStorage.getItem("LTRole"),
          cdRole: localStorage.getItem("CDRole"),
          ltRegion: localStorage.getItem("LTRegion")
        }
      }
    )
      .then(function (response) {
        if (response?.data === "LT Planner Material mapping deleted successfully") {
          toast.success("LT Planner Material mapping deleted successfully", {
            autoClose: 2000,
          });
          setEditModalOpen(false);
          onClickSearchButton()
        }

      })
      .catch(function (error) {
        console.log(error);
        setEditModalOpen(false);
      });

  }
  const editModelColumn = EditPlannerMaterialHeaders(onClickEditExistingRecords, onClickDeleteLineItem, userRole);
  const gridOptions = {
    getRowId: (params) => {
      return params?.data?.uniqueId
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressMiniFilter: false,
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              excelMode: 'windows',
              suppressMiniFilter: false,
              buttons: ['apply', 'reset'],
            },
          },
        ],
      },
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === "" ? "-" : value;
      },
    }

  }
  const onCloseEditModal = () => {
    setSelectedEditPlanner({})
    setEditModalOpen(false);
  }
  const handleEditModelSubmitButton = async () => {
    const userEmail = localStorage.getItem("data");

    const editModalRequestBody = {
      "userEmail": userEmail,
      "plannerName": selectedEditPlanner?.name,
      "plannerEmail": selectedEditPlanner?.email
    }

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    localStorage.setItem('accessToken', accessToken);

    try {
      const responseEditLTPlannerMaterial = await dispatch(postEditLTPlannerMaterial({
        dynamicEndpoint: `${updateLtPlannerMaterialEndpoint}/${selectedEditItem.uniqueId}`,
        data: editModalRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseEditLTPlannerMaterial.meta.requestStatus === 'fulfilled') {
        toast.success(responseEditLTPlannerMaterial?.payload, {
          autoClose: 2000,
        });
        setSelectedEditPlanner({})
        setEditModalOpen(false);
        onClickSearchButton()
      } else {
        toast.error(responseEditLTPlannerMaterial?.error, {
          autoClose: 2000,
        });
        setSelectedEditPlanner({})
        setEditModalOpen(false);
      }
    } catch (error) {
      console.error('API error:', error);
    }

  }

  const RenderEditModalContent = ({ data }) => {
    return (
      <div className='renderEditModal_main'>
        <div className='renderEditModal_Headers'>
          <div className='header_box'><b >Plant</b>:<p>{data.plant}</p></div>
          <div className='header_box'><b >Purchasing Group</b>:<p>{data.purchasingGroup}</p></div>
          <div className='header_box'><b >Planner</b>:<p>{data.plannerName}</p></div>
          <div className='header_box'><b >Email</b>:<p>{data.plannerEmail}</p></div>
          <div className='header_box'><b >S-Code (Ext Material Group)</b>:<p>{data.scode}</p></div>
          <div className='header_box'><b >Material Type</b>:<p>{data.materialType}</p></div>
          <div className='header_box'><b >Material Group</b>:<p>{data.materialGroup}</p></div>
          <div className='header_box'><b >Material</b>:<p>{data.materialId}</p></div>
          <div className='header_box'><b >Role</b>:<p>{data.role}</p></div>
        </div>
        <div className='editMRPdropdown'>
          <div className="parameter-dropdowns">
            <span>Planner to be mapped</span>
            <Autocomplete
              className="custom-autocomplete"
              disablePortal
              freeSolo
              value={selectedEditPlanner}
              options={data.role === "Planner" ? mrpControllerEmailData : GMPEmailData}
              getOptionDisabled={(option) => option?.email === data.plannerEmail}
              getOptionLabel={(option) => option?.name || ""}
              renderInput={(params) => <TextField {...params}
                placeholder="Search"
                InputLabelProps={{ shrink: false }}
                sx={{
                  "& .MuiInputLabel-root": {
                    marginTop: '-6px'
                  }
                }}
              />}
              onChange={(event, value) => handlEditMRP(event, value)}
              style={{ height: 40, maxWidth: 220 }}
            />
          </div>
          <div className="parameter-dropdowns">
            <span>Email</span>
            <ActionInput
              props={{ height: "40px", maxWidth: "220px", }}
              placeholder='Email'
              disabled={true}
              value={selectedEditPlanner?.email || ""}
            />
          </div>

        </div>
      </div>
    )

  }
  const RenderEditModalFooter = () => {
    return (
      <div style={{ display: 'flex', gap: 10 }}>
        <ButtonComponent
          maxWidth="170px"
          label="Cancel"
          bgColor="white"
          color="black"
          onClick={onCloseEditModal}
        />
        <ButtonComponent
          maxWidth="170px"
          label="Submit"
          bgColor="black"
          color="white"
          onClick={handleEditModelSubmitButton}
          disabled={!selectedEditPlanner?.email}
        />
      </div>
    )
  }

  return (
    (stateSelector?.LTPlannerMaterialDropdownDataSlice?.loading || stateSelector?.GetAllUsers.loading || stateSelector?.SaveLTPlannerMaterialSlice?.loading) ?
      <Loader />
      :
      <>
        <TopSection
          tabTitle="Planner Material Mapping"
          labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Planner-Material Mapping" },
          ]}
        />
        <div className="main-container paramaeter-tab-container">
          <div className="tab-part">
            <TabSection
              style={{ maxWidth: "450px", marginBottom: "30px", width: "100%" }}
              label={userRole === "Viewer" ? ["Manual Update"] : ["Manual Update", "Excel Update"]}
              value={tabValue}
              handleChange={handleChange}
            />
            {tabValue === 0 ?
              (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Plant</span>
                        {/* <Dropdown
                          maxWidth="100%"
                          label="Select Plant"
                          value={plantData || ""}
                          name="plant"
                          options={getUniqueValues(dropdownData, 'plant')}
                          handleChange={(event) => handleSelectedItemsChange('plant', event)}
                        /> */}
                        <MultiDropdown
                          id="plant"
                          name="plant"
                          options={getUniqueValues(dropdownData, 'plant') || []}
                          selectedItemsData={formData?.plant || []}
                          onChangeItems={handleSelectedItemsChange}
                        // disabled={singleDropdownData?.plant?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Purchasing Group</span>
                        <MultiDropdown
                          id="purchasingGroup"
                          name="purchasingGroup"
                          options={getUniqueValues(purchasingGroupData, 'purchasingGroup')}
                          selectedItemsData={formData?.purchasingGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.plant?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>S-Code (Ext Material Group)</span>
                        <MultiDropdown
                          id="scode"
                          name="scode"
                          options={getUniqueValues(scodeData, 'scode')}
                          selectedItemsData={formData?.scode}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.purchasingGroup?.length === 0}
                        />
                      </div>


                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Material Type</span>
                        <MultiDropdown
                          id="materialType"
                          name="materialType"
                          options={getUniqueValues(materialTypeData, 'materialType')}
                          selectedItemsData={formData?.materialType}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.scode?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Material Group</span>
                        <MultiDropdown
                          id="materialGroup"
                          name="materialGroup"
                          options={getUniqueValues(materialGroupData, 'materialGroup')}
                          selectedItemsData={formData?.materialGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialType?.length === 0}
                        />
                      </div>

                      <div className="parameter-dropdowns">
                        <span>Material</span>
                        <MultiDropdown
                          id="materialId"
                          name="materialId"
                          options={getUniqueValues(materialIdData, 'materialId')}
                          selectedItemsData={formData?.materialId}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialGroup?.length === 0}
                        />
                      </div>
                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Role</span>
                        <Dropdown
                          maxWidth="100%"
                          label="Select Role"
                          value={selectedRole || ""}
                          name="role"
                          options={[{ label: 'Planner', value: "Planner" }, { label: 'GMP', value: "GMP" }]}
                          handleChange={(event) => handleSelectedRole(event)}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Planner to be mapped</span>
                        <Autocomplete
                          className="custom-autocomplete"
                          disablePortal
                          freeSolo
                          value={selectedPlanner}
                          options={selectedRole === "Planner" ? mrpControllerEmailData : selectedRole === "GMP" ? GMPEmailData : []}
                          getOptionLabel={(option) => option?.name || ""}
                          renderInput={(params) => <TextField {...params}
                            placeholder="Search"
                            InputLabelProps={{ shrink: false }}
                            sx={{
                              "& .MuiInputLabel-root": {
                                marginTop: '-6px'
                              }
                            }}
                          />}
                          onChange={(event, value) => handlePlannerChange(event, value)}
                          style={{ height: 40, maxWidth: '100%' }}
                          disabled={!selectedRole}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Email</span>
                        <ActionInput
                          props={{ height: "40px", maxWidth: "100%", }}
                          placeholder='Email'
                          disabled={true}
                          value={selectedPlanner?.email || ""}
                        />
                      </div>

                    </div>
                    <div className="parameter-dropdowns" style={{ justifyContent: 'center', marginTop: 25, textAlign: 'center' }}>
                      <ButtonComponent
                        type="secondary"
                        maxWidth="120px"
                        label="Search"
                        height="40px"
                        onClick={onClickSearchButton}
                        disabled={(formData?.materialId?.length === 0)}
                      />
                    </div>
                  </div>
                </>)
              :
              (
                <>
                  <ExcelUpdate getFileDetails={getFileName} templateName={"PlannerMaterialTemplate"} url={"/api/admin/downloadLtPlannerMaterialCsv"} isUploadFileSelected={isUploadFileSelected} excelLoader={excelLoader} />
                </>)
            }
          </div>
        </div>
        {stateSelector?.SearchLTPlannerMaterialSlice?.loading ? <Loader /> :
          <div style={{ margin: '10px 0px' }}>
            {searchResults?.length > 0 && show && tabValue === 0 && <DataTable
              height={searchResults?.length <= 2 ? 220 : 400}
              columns={editModelColumn}
              gridOptions={gridOptions}
              rows={searchResults}
              paginationProp={pagination}
              paginationPageSize={paginationPageSize}
              paginationPageSizeSelector={paginationPageSizeSelector}

            />}
            {searchResults && Object?.keys(searchResults).length === 0 && show && tabValue === 0 ?
              <div style={{ margin: '20px 5px', border: '1px solid #bcbcbc' }}><p style={{ textAlign: 'center' }}>No Data Found</p></div> :
              <></>}
          </div>
        }
        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "30px",
          }}
        >
          {tabValue === 0 ? (
            userRole !== "Viewer" &&
            (<div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 10
              }}
            >
              <ButtonComponent
                label="Clear All"
                bgColor="#fff"
                color="#000"
                onClick={clearAllData}
              />
              <ButtonComponent
                label="Submit"
                bgColor="#000"
                color="#fff"
                onClick={handleManualDataSubmit}
                disabled={(formData?.materialId?.length === 0) || (selectedPlanner?.email === undefined)}
              />
            </div>)
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 10
              }}
            >
              <ButtonComponent
                label="File Upload Overview"
                bgColor="#fff"
                color="#000"
                onClick={() => setOverview(true)}
                disabled={isWindowFileSelected || excelLoader}
              />
              <ButtonComponent
                label="Save"
                bgColor="#000"
                color="#fff"
                onClick={handleFileSaveAPI}
                disabled={!fileName || excelLoader}
              />
            </div>
          )}
          <Modal
            open={overview}
            handleClose={() => {
              setOverview(false);
            }}
            title="File Upload Overview"
            action={
              <FileOverivewFooter
                close={() => {
                  setOverview(false);
                }}
              />
            }
            content={<FileOverivew fileName={fileName} fileOverviewDetails={fileOverviewDetails} />}
            maxWidth="100px"
          />

        </div>
        <Modal title="Edit"
          open={editModalOpen}
          handleClose={onCloseEditModal}
          content={
            <RenderEditModalContent data={selectedEditItem} />
          }
          action={
            <RenderEditModalFooter />
          }
          maxWidth="lg"
        />
      </>
  );
}

export default PlannerMaterialMapping